import { isEqual } from "lodash-es";

export function compareObjects(obj1: Record<string, any>, obj2: Record<string, any>, key: string) {
  const array1 = obj1[key];
  const array2 = obj2[key];

  return isEqual(array1, array2);
}
